import Text from 'components/common/BaseText/BaseText'
import { ProductsCardProps } from './Products.types'
import './ProductsCard.scss'

const ProductsCard: React.FC<ProductsCardProps> = ({ icon, title, subtitle }) => {
	return (
		<div className='products-card'>
			{icon}
			<p className='products-card__title'>{title}</p>
			<Text>{subtitle}</Text>
		</div>
	)
}

export default ProductsCard
